import { useAuthInfiniteList } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { ContentsApi } from 'api';
import {
  ContentsPageType,
  IContent,
  SearchContentsFilterType,
  SearchContentsQueryType,
} from 'types';
import { KEY } from './keys';

function useGetInfinite(filter: SearchContentsFilterType, size = 30) {
  return useAuthInfiniteList<IContent>(
    [...getQueryKeys(KEY).lists(), 'infinite', { ...filter, size }],
    async (page) => {
      const query: SearchContentsQueryType & { pageType: ContentsPageType } = {
        ...filter,
        pageType: 'LIST',
        page,
        size,
      };
      const res = await ContentsApi.getAll(query);
      return {
        data: { data: res.data.data, totalPages: res.data.totalPage },
      };
    },
  );
}

export default useGetInfinite;
